import { render, staticRenderFns } from "./addpayment.vue?vue&type=template&id=5a08b1a4"
import script from "./addpayment.vue?vue&type=script&lang=js"
export * from "./addpayment.vue?vue&type=script&lang=js"
import style0 from "./addpayment.vue?vue&type=style&index=0&id=5a08b1a4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports